<template>
    <v-container>
        <v-row>
            <v-col 
                :cols="(data.cols) ? data.cols.mobile : 10"
                :md="(data.cols) ? data.cols.tablet  : 8"
                :lg="(data.cols) ? data.cols.desktop  : 6"
                class="mx-auto" 
                data-aos="fade-right" 
                >
                <dialog-simple width="1200" 
                btnBlock
                btnClass="rounded-pill"
                btnSize="large"
                :btnVariant="data.button.variant"
                :btnColor="data.button.color"
                :btnText="t('commons.expert-modal.button')" 
                :title="t('commons.expert-modal.title')">

                  <v-row>
                    <v-col cols="12"> 
                        <v-tabs grow v-model="tab" @update:modelValue="changeTab">
                            <v-tab value="short_term" >
                                {{ t('commons.short-term') }}
                            </v-tab>
                            <v-tab value="long_term" v-if="locale=='it'">
                                {{ t('commons.medium-term') }}
                            </v-tab>
                        </v-tabs>
                    </v-col>
                    <v-col cols="12" v-if="current_page" :key="tab">
                        <!-- <ConsultingForm 
                            :button="t('commons.expert-modal.button')" 
                            :model="{name: current_page.title, id:current_page.drive_model_id}"
                            :type="{name: current_page.type.title,id:current_page.type.drive_id} "
                            :brand="{name: current_page.brand.title,id:current_page.brand.drive_id} "
                        >
                        </ConsultingForm> -->

                    <RequestQuoteComponent :data="requestquote"></RequestQuoteComponent>

                    </v-col>
                  </v-row>

                </dialog-simple>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
    // import ConsultingForm from './subComponents/ConsultingForm.vue'
    import RequestQuoteComponent from './RequestQuoteComponent.vue'
    import { useLocale } from 'vuetify'
    const { t } = useLocale()
    
</script>

<script>
import {mapGetters} from "vuex";
const locale = localStorage.getItem('locale')
export default {
    name: "ModalConsultingComponent",
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
            page: 'pages/single',
            adminPage: 'AdminPages/single',
        }),
    },
    data: () => ({
        tab: "short_term",
        title: null,
        current_page: null,
        requestquote: {
        "class": "",
        "title": "Request a quote",
        "sub_title": "Mid Term",
        locale: locale,
        "has_image": false,
        "image": {
           
        },
        "form": {
            "scope": "short-term-quotations",
            "fromUrl": null,
            "car": {
                "type": null,
                "model": null,
                "brand": null
            },
            "rental": {
                "start": null,
                "end": null,
                "duration": null
            },
            "firstName": null,
            "lastName": null,
            "email": null,
            "phone": null,
            "phone_prefix": null,
            "city": null,
            "address": null,
            "message": null,
            "privacy": null
        }
        }
    }),
    mounted(){
        this.current_page = (this.page) ? this.page : this.adminPage;
        this.requestquote.title = this.$vuetify.locale.t('commons.expert-modal.title')
        this.requestquote.sub_title = this.$vuetify.locale.t('commons.expert-modal.sub_title')

        this.requestquote.showcarselect = false
        this.requestquote.form.car =  {
            model: {id:this.current_page.drive_model_id},
            type: {id:this.current_page.type.drive_id},
            brand: {id:this.current_page.brand.drive_id},
        }
    },
    methods:{
        changeTab(tab){
            if(tab == "short_term"){
                this.requestquote.form.scope = "short-term-quotations"
            }else{
                this.requestquote.form.scope = "medium-term-quotations"
            }
        }
    }
}
</script>